import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-64c116bf")

_pushScopeId("data-v-64c116bf")
const _hoisted_1 = { class: "cc-wrap" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "cct-title" }, "自定义案例", -1)
const _hoisted_3 = { class: "card-wrap" }
const _hoisted_4 = { class: "card-bottom flex flex-column" }
const _hoisted_5 = { class: "card-title mb14" }
const _hoisted_6 = { class: "flex justify-between" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "card-type" }, null, -1)
const _hoisted_8 = { class: "card-btn-group flex" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "mr4" }, "/", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "mr4" }, "/", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("是否复制此案例？")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("是否删除此案例？")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_a_pagination = _resolveComponent("a-pagination")
  const _component_ManagementFrame = _resolveComponent("ManagementFrame")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_ManagementFrame, { items: ["自定义案例"] }, {
      title: _withId(() => [
        _hoisted_2
      ]),
      controllers: _withId(() => [
        _createVNode("span", {
          class: "cct-add pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push("/Teacher/customCase/edit")))
        }, "新增案例"),
        _createVNode(_component_SvgIcon, {
          class: "cct-back pointer",
          icon: "back",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.backToTeacherHome(_ctx.$router)))
        })
      ]),
      content: _withId(() => [
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.customCase.caseList.value, (ccase, caseIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "card-box",
              key: ccase.id
            }, [
              _createVNode("img", {
                class: "card-img",
                src: ccase.caseImg
              }, null, 8, ["src"]),
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, _toDisplayString(ccase.caseName), 1),
                _createVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", {
                      class: "pointer mr4",
                      onClick: ($event: any) => (_ctx.customCaseController.handleEditClick(ccase.id,$event))
                    }, "编辑", 8, ["onClick"]),
                    _hoisted_9,
                    _createVNode("div", {
                      class: "pointer mr4",
                      onClick: ($event: any) => (_ctx.customCaseController.handleCopyClick(ccase.id))
                    }, "复制", 8, ["onClick"]),
                    _hoisted_10,
                    _createVNode("div", {
                      class: "pointer",
                      onClick: ($event: any) => (_ctx.customCaseController.handleDeleteClick(ccase.id))
                    }, "删除", 8, ["onClick"])
                  ])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      pagination: _withId(() => [
        _createVNode(_component_a_pagination, {
          class: "flex justify-end",
          "show-quick-jumper": "",
          total: _ctx.customCase.pagination.totals,
          current: _ctx.customCase.pagination.pageNo,
          "onUpdate:current": _cache[3] || (_cache[3] = ($event: any) => (_ctx.customCase.pagination.pageNo = $event)),
          "page-size": _ctx.customCase.pagination.pageSize,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.customCaseController.handlePageChange($event)))
        }, null, 8, ["total", "current", "page-size"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.customCase.modals.modalCopy,
      onOnOk: _cache[5] || (_cache[5] = ($event: any) => (_ctx.customCaseController.confirmModalCopy())),
      onOnCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.customCaseController.cancelModalCopy())),
      loading: _ctx.customCase.modals.copying
    }, {
      content: _withId(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["visible", "loading"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.customCase.modals.modalDelete,
      onOnOk: _cache[7] || (_cache[7] = ($event: any) => (_ctx.customCaseController.confirmModalDelete())),
      onOnCancel: _cache[8] || (_cache[8] = ($event: any) => (_ctx.customCaseController.cancelModalDelete())),
      loading: _ctx.customCase.modals.deleting
    }, {
      content: _withId(() => [
        _hoisted_12
      ]),
      _: 1
    }, 8, ["visible", "loading"])
  ]))
})